import { render, staticRenderFns } from "./language.vue?vue&type=template&id=54bd330a&scoped=true"
import script from "./language.ts?vue&type=script&lang=ts&external"
export * from "./language.ts?vue&type=script&lang=ts&external"
import style0 from "./language.scss?vue&type=style&index=0&id=54bd330a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd330a",
  null
  
)

export default component.exports